// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/WebhookLogs_DetalheResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /webhook_logs/detalhe endpoint
 *
 * Returns a single webhook log with decoded payload
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface WebhookLogs_DetalheResponseDados {
id: number
provider: string
status: string
created_at: string
event_type?: string
event_id?: string
payload?: unknown
error_message?: string
processed_at?: string
ip_address?: string
}

export type WebhookLogs_DetalheResponse = ApiResponse<WebhookLogs_DetalheResponseDados>;

registerResponseContract('WebhookLogs_DetalheResponse', {
  id:            { type: 'number',  required: true },
  provider:      { type: 'string',  required: true },
  status:        { type: 'string',  required: true },
  created_at:    { type: 'string',  required: true },
  event_type:    { type: 'string',  required: false },
  event_id:      { type: 'string',  required: false },
  payload:       { type: 'object',  required: false },
  error_message: { type: 'string',  required: false },
  processed_at:  { type: 'string',  required: false },
  ip_address:    { type: 'string',  required: false },
})
